var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "dialog",
        height: "auto",
        classes: ["v--modal", "vue-dialog", "modal-mask"],
        width: _vm.width,
        "pivot-y": 0.3,
        adaptive: true,
        clickToClose: _vm.clickToClose,
        transition: _vm.transition
      },
      on: {
        "before-open": _vm.beforeOpened,
        "before-close": _vm.beforeClosed,
        opened: function($event) {
          return _vm.$emit("opened", $event)
        },
        closed: function($event) {
          return _vm.$emit("closed", $event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal_size", class: [this.params.class] }, [
          _c(
            "dl",
            { staticClass: "modal_content alert_msg" },
            [
              _c("dt", { staticClass: "ellipsis" }, [
                _vm.params.title
                  ? _c("h5", {
                      attrs: { name: "header" },
                      domProps: { innerHTML: _vm._s(_vm.params.title || "") }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.params.component
                ? _c(
                    _vm.params.component,
                    _vm._b(
                      { tag: "component" },
                      "component",
                      _vm.params.props,
                      false
                    )
                  )
                : _c("dd", {
                    domProps: { innerHTML: _vm._s(_vm.params.text || "") }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _vm.buttons
            ? _c(
                "div",
                {
                  staticClass: "btn_modal_wrap",
                  class: _vm.buttons.length === 2 ? "set_2" : ""
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn_right" },
                    _vm._l(_vm.buttons, function(button, i) {
                      return _c(
                        "a",
                        {
                          key: i,
                          class: button.default ? "btn_white" : "btn_blue",
                          attrs: { href: "javascript:", type: "button" },
                          domProps: { innerHTML: _vm._s(button.title) },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.click(i, $event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(button.title) +
                              "\n                    "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _c("div", { staticClass: "vue-dialog-buttons-none" }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "javascript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.closeClick($event)
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b0b6380", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0b6380","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/modal/Dialog.vue
// module id = tbR3
// module chunks = 0